/**
 * ChatbotController - Contrôleur pour le composant de chatbot
 */
angular
  .module('chatbotModule')
  .controller('ChatbotController', ChatbotController);

ChatbotController.$inject = ['$scope', '$timeout', 'ChatbotService'];

function ChatbotController($scope, $timeout, ChatbotService) {
  var vm = this;
  
  // Initialisation des données du chatbot
  vm.messages = [];
  vm.question = '';
  vm.isExpanded = false;
  vm.isLoading = false;
  vm.questionsSuggerees = [];
  
  // Fonctions exposées
  vm.envoyerQuestion = envoyerQuestion;
  vm.suggererQuestion = suggererQuestion;
  vm.toggleChatbot = toggleChatbot;
  
  // Initialisation
  initialiser();
  
  /**
   * Initialisation du chatbot
   */
  function initialiser() {
    // Message de bienvenue
    vm.messages.push({
      type: 'bot',
      text: 'Bonjour ! Je suis votre assistant virtuel pour les questions concernant les finances publiques et le secteur extractif au Tchad. Comment puis-je vous aider ?',
      timestamp: new Date()
    });
    
    // Chargement des questions fréquentes
    chargerQuestionsSuggerees();
  }
  
  /**
   * Charger la liste des questions suggérées
   */
  function chargerQuestionsSuggerees() {
    ChatbotService.getQuestionsFrequentes().then(function(data) {
      vm.questionsSuggerees = data;
    }).catch(function(error) {
      console.error('Erreur lors du chargement des questions suggérées', error);
      // Questions par défaut en cas d'erreur
      vm.questionsSuggerees = [
        'Quel est le budget de l\'État tchadien pour 2024 ?',
        'Comment sont réparties les recettes pétrolières ?',
        'Quelles sont les entreprises minières actives au Tchad ?',
        'Comment sont utilisés les revenus du secteur extractif ?'
      ];
    });
  }
  
  /**
   * Envoie une question au chatbot
   */
  function envoyerQuestion() {
    // Vérification que la question n'est pas vide
    if (!vm.question || vm.question.trim() === '') {
      return;
    }
    
    // Ajout de la question au fil de discussion
    vm.messages.push({
      type: 'user',
      text: vm.question,
      timestamp: new Date()
    });
    
    // Indication de chargement
    vm.isLoading = true;
    
    // Sauvegarde et réinitialisation de la question
    var question = vm.question;
    vm.question = '';
    
    // Appel au service
    ChatbotService.envoyerQuestion(question)
      .then(function(response) {
        // Ajout de la réponse au fil de discussion
        vm.messages.push({
          type: 'bot',
          text: response.réponse,
          data: response.données,
          references: response.références,
          timestamp: new Date()
        });
        
        // Si des questions complémentaires sont suggérées
        if (response.suggerees && response.suggerees.length > 0) {
          vm.questionsSuggerees = response.suggerees;
        }
      })
      .catch(function(error) {
        console.error('Erreur lors de l\'envoi de la question', error);
        // Message d'erreur
        vm.messages.push({
          type: 'bot',
          text: 'Désolé, je rencontre un problème technique. Veuillez réessayer plus tard.',
          timestamp: new Date(),
          isError: true
        });
      })
      .finally(function() {
        vm.isLoading = false;
        // Scroll vers le bas pour voir la dernière réponse
        $timeout(function() {
          var chatbox = document.querySelector('.chatbot-messages');
          if (chatbox) {
            chatbox.scrollTop = chatbox.scrollHeight;
          }
        }, 100);
      });
  }
  
  /**
   * Sélectionne une question suggérée
   */
  function suggererQuestion(question) {
    vm.question = question;
    envoyerQuestion();
  }
  
  /**
   * Ouvre ou ferme le chatbot
   */
  function toggleChatbot() {
    vm.isExpanded = !vm.isExpanded;
    
    // Scroll vers le bas quand on ouvre le chatbot
    if (vm.isExpanded) {
      $timeout(function() {
        var chatbox = document.querySelector('.chatbot-messages');
        if (chatbox) {
          chatbox.scrollTop = chatbox.scrollHeight;
        }
      }, 100);
    }
  }
}
